"use strict";

/**
 * @classdesc
 * Implementierung des FeatureInfo-Providers für WFS-Layer auf Basis OpenLayers3.
 *
 * @class
 * @extends gc.gis.module.GCFeatureInfoProvider
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.module.GCFeatureInfo} module Referenz auf das Feature-Info-Modul
 */
gc.gis.module.GCFeatureInfoProvider.OLWFSLayer = function(module)
{
    gc.gis.module.GCFeatureInfoProvider.call(this, module);
};
gc.gis.module.GCFeatureInfoProvider.OLWFSLayer.prototype = Object.create(gc.gis.module.GCFeatureInfoProvider.prototype);


/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfoProvider.OLWFSLayer.prototype.identify = function (layer, geometry, opt_limit)
{
    console.debug("Identify WFS-Layer.");
};


/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfoProvider.OLWFSLayer.prototype.renderDetail = function (layer, result)
{
    console.debug("Render detail WFS-Layer.");
};